// toastname : success, danger, warning

export function showToast(toastName, message = "Validation") {
    const toast = document.getElementById(`toast-${toastName}`);
    toast.querySelector('.toast-message').innerHTML = message;
    toast?.classList.remove("opacity-0", "translate-y-2", "pointer-events-none");
    toast?.classList.add("opacity-100", "translate-y-0");

    // Ajouter l'event listener au bouton close
    const closeBtn = toast.querySelector('[data-dismiss-target]');
    closeBtn?.addEventListener('click', () => hideToast(toastName));

    // Auto-hide après 60 sec
    setTimeout(() => {
        hideToast(toastName);
    }, 20000);
}

export function hideToast(toastName) {
    // console.log("Cacher");
    const toast = document.getElementById(`toast-${toastName}`);
    toast?.classList.remove("opacity-100", "translate-y-0");
    toast?.classList.add("opacity-0", "translate-y-2", "pointer-events-none");
}